module.exports = __webpack_public_path__ + "448fc22b0dd0abd9ef412eb90e48fe6f.svg";